import { render, staticRenderFns } from "./CockpitStage.vue?vue&type=template&id=606b71b8&scoped=true"
import script from "./CockpitStage.vue?vue&type=script&lang=js"
export * from "./CockpitStage.vue?vue&type=script&lang=js"
import style0 from "./CockpitStage.vue?vue&type=style&index=0&id=606b71b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606b71b8",
  null
  
)

export default component.exports